module.exports = __webpack_public_path__ + "img/s5-v2.027b26c0.png";